<template>
    <div class="main-menu-view">
        <div class="main-btn">
            <i class="align-middle me-2 fas fa-fw fa-bars text-white"
                ref="mainBtn" 
                @click="toggleNavBar"
            ></i>
        </div>
        <ul class="nav-bar mb-0"
            :class="{ show: isNavBarVisible }"
            ref="navBar"
        >
            <li class="user-info-view mb-3">
                <img v-if="user_img"
                    class="mb-2"
                    :src="$api.files.getImage($shared.getFilePath(user_img))"/>
                <span>{{ user_name }} <small>您好</small></span>
                <small>{{ user_email }}</small>
            </li>
            <li >
                <router-link to="/dashboard"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'dashboard'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-solar-panel"></i><span>DashBoard</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('ack')"
            >
                <router-link to="/intake"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'intake'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-clipboard-list"></i><span>受理單管理</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('medical')"
            >
                <router-link to="/healthRecord/list/inHospitalList"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'healthRecord'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-address-card"></i><span>病歷管理</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('ft')"
                class="dropdown"
            >
                <a class="router-link-active dropdown-toggle" 
                    :class="{'selected':$store.state.nowPage == 'releaseInWild'}"
                    id="releaseTrainingDropdown" 
                    ref="releaseDropdown"
                    @click="toggleDropdown"
                >   
                    <i class="align-middle me-1 fas fa-fw fa-mountain-sun"></i><span>野放管理</span>
                </a>
                <div 
                    class="dropdown-menu show" v-if="isDropdownOpen" aria-labelledby="releaseTrainingDropdown" ref="dropdownMenu">
                    <router-link 
                        to="/releaseInWild/plan"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-clipboard-check"></i><span class="">野訓計畫</span>
                    </router-link>
                    <router-link 
                        v-if="$api.users.checkSubPermission('ft','tracking')"
                        to="/releaseInWild/map"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-shoe-prints"></i><span class="">野放追蹤</span>
                    </router-link>
                </div>
            </li>
            <li 
                v-if="$api.users.checkPermission('examManager')"
            >
                <router-link 
                    to="/testManager/list"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'testManager'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-vial-circle-check"></i><span>檢驗管理</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('inv')"
            >
                <router-link to="/inStock/list"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'inStock'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-boxes"></i><span>庫存管理</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('mis')"
            >
                <router-link to="/task/list"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'task'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-tasks"></i><span>任務管理</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('typeSurvey')"
            >
                <router-link to="/typeSurvey"
                    class="router-link-active"
                    :class="{'selected':$store.state.nowPage == 'typeSurvey'}"
                >
                    <i class="align-middle me-1 fas fa-fw fa-ruler-combined"></i><span>型質測量</span>
                </router-link>
            </li>
            <li 
                v-if="$api.users.checkPermission('diss')"
            >
                <router-link to="/dissectReport"
                    class="router-link-active"
                >
                    <i class="align-middle me-1 fas fa-fw fa-microscope"></i><span>解剖管理</span>
                </router-link>
            </li>
        </ul>
    </div>
    
</template>
  
<script>
export default {
    name: 'mainMenuView',
    data() {
        return {
            isDropdownOpen: false,
            userPermission:null,
            isNavBarVisible: false, // 控制 nav-bar 顯示狀態
            user_name: 'No Name'
            , user_img: null
            , user_email: 'No email'
        };
    },
    watch: {
        $route(to, from) {
            this.isDropdownOpen = false;
            this.isNavBarVisible = false
        },
        isDropdownOpen(value) {
            if (value) {
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        isNavBarVisible(value) {
            if (value) {
                document.addEventListener('click', this.handleNavClickOutside);
            } else {
                document.removeEventListener('click', this.handleNavClickOutside);
            }
        }
    },
    computed:{
    
    },
    methods: {
        toggleNavBar() {
            this.isNavBarVisible = !this.isNavBarVisible;
        },
        hideNavBar() {
            this.isNavBarVisible = false;
        },
        handleNavClickOutside(event) {
            const navBar = this.$refs.navBar;
            const mainBtn = this.$refs.mainBtn;
            // 如果點擊的區域不是 navBar 或 mainBtn，則隱藏 nav-bar
            if (!navBar.contains(event.target) && !mainBtn.contains(event.target)) {
                this.hideNavBar();
            }
        },
        toggleDropdown(event) {
            event.stopPropagation();  // 防止點擊下拉按鈕本身時觸發 handleClickOutside
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        handleClickOutside(event) {
            const dropdownMenu = this.$refs.dropdownMenu;
            const releaseDropdown = this.$refs.releaseDropdown;
            if (
                this.isDropdownOpen &&
                dropdownMenu &&
                !dropdownMenu.contains(event.target) &&
                !releaseDropdown.contains(event.target)
            ) {
                this.isDropdownOpen = false;
            }
        },
        checkPermission(key){
            const permission = this.userPermission.find(item=>item.key===key)
            return permission ? permission.status : false
        },
        checkSubPermission(key,subKey){
            const permission = this.userPermission.find(item=>item.key===key)
            if ( ( permission ? permission.status : false ) ){
                const subPermission = permission.sub.find(item=>item.key===subKey)
                return subPermission ? subPermission.status : false
            }
            return false
        }
    },
    created(){
        const userPermission = this.$api.users.getUserPermission()
        if ( userPermission == null ){
            this.$router.push('/login')
            return
        }
        this.userPermission = userPermission.role_permission_json

        const userData = this.$api.users.getUserData()
        this.user_name = userData ?  userData.name : 'No Name'
        this.user_img = userData ?  userData.img_src : null
        this.user_email = userData ?  userData.email : null

        // 點擊畫面其他區域時關閉 nav-bar
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('click', this.handleNavClickOutside);
    },
    beforeUnmount() {
        // 移除事件監聽
        document.removeEventListener('click', this.handleClickOutside);
        document.removeEventListener('click', this.handleNavClickOutside);
    },
};

</script>
<style scoped>
.nav-bar{
    list-style: none;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    font-size: 1.1rem;
    font-weight: lighter;
}
.nav-bar > li {
    margin-right: 0rem;
}
.nav-bar > li:last-child {
    margin-right: 0rem;
}
.nav-bar > li > .router-link-active {
    color:#ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.825rem;
    cursor: pointer;
    text-decoration:none;
}
.nav-bar > li > .router-link-active:hover{
    border-radius: 20px;
    background-color: #2d538b;
    font-weight: 400;
    text-decoration:none;
}
.nav-bar > li > .router-link-active.selected{
    border-radius: 20px;
    background-color: #ffffff;
    color: #153d77;
    font-weight: 400;
    text-decoration:none;
}
.dropdown-toggle:after {
  content: none; /* 移除原有的向下箭頭 */
}
.dropdown-item {
    display: flex;
    align-items: baseline;
}
.dropdown-item:hover {
    background-color: #d8d8d8;
}
.main-menu-view{
    display: flex;
    align-items: center;
}
.main-btn{
    display: none;
    font-size: 1.325rem;
    padding-left: 1rem;
}
.dropdown, .dropleft, .dropright, .dropup {
    position: relative !important;
}
.user-info-view{
    display: none;
}
.user-info-view > img {
    width:84px;
    height:84px;
    border-radius: 50%;
}
.user-info-view > span {
    font-weight: 500;
}
@media screen and (max-width: 1529px) {
    .user-info-view{
        display: grid;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .main-menu-view{
        position: relative;
    }
    .main-btn{
        display: block;
    }
    .nav-bar{
        position: fixed;
        top: 0;
        left: 0;
        transform: translate(-100%, 0%);
        padding: .5rem 1rem;
        display: flex;
        background-color: #ffffff;
        /* border-radius: 4px; */
        box-shadow: 1px 1px 6px #0000003c;
        z-index: 1050;
        gap: .75rem;
        min-width: 16rem;
        height: 100%;
        align-items: start;
        flex-direction: column;
        transition: transform 0.3s ease; /* 添加過渡效果 */
        padding-top: 2rem;
    }
    .nav-bar.show{
        transform: translate(0, 0); /* 顯示位置：滑入 */
    }
    .nav-bar > li {
        width: 100%;
    }
    .nav-bar > li > .router-link-active {
        font-size: 0.9375rem;
        color: #495057;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0.5rem 0.825rem;
        cursor: pointer;
        text-decoration:none;
        white-space: nowrap;
        font-weight: 400;
        
    }
    .nav-bar > li > .router-link-active > i {
        margin-right: .5rem;
    }
    
    .nav-bar > li > .router-link-active:hover{
        border-radius: 4px;
        background-color: #153d77;
        color: #feffff;
        font-weight: 400;
        text-decoration:none;
    }
    .nav-bar > li > .router-link-active.selected{
        border-radius: 4px;
        background-color: #153d77;
        color: #feffff;
        font-weight: 400;
        text-decoration:none;
    }
}
/* @media screen and (max-width: 1610px) {
    .nav-bar {
        overflow-x: auto;
        flex-wrap: nowrap;
        font-size:0.9rem;
    }
}
@media screen and (max-width: 1443px) {
    .nav-bar {
        overflow-x: auto;
        flex-wrap: nowrap;
        font-size:0.75rem;
    }
}
@media screen and (max-width: 1325px) {
    
    .nav-bar > li > .router-link-active > span {
        white-space: nowrap;
    }
}
@media (max-width: 767px) {
    .nav-bar{
        margin-top:1.25rem;
        padding: 0 !important;
        overflow-x: auto;
        flex-wrap: nowrap;
        padding-bottom: .5rem !important;
    }
    .nav-bar > li{
        font-size: 1rem;
    }
} */
</style>